import TravelRequestLocal from "./TravelRequestLocal";
import CertificateOfServicePage from "./CertificateOfServicePage";
import CertificateOfWorkAccomplishmentPage from "./CertificateOfWorkAccomplishmentPage";
import FacultyServiceRecordPage from "./FacultyServiceRecordPage";

import { setTrTab } from "../../state/slices/generalSlice";

import {
  CarFilled,
  CarryOutOutlined,
  FileDoneOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import TabSelection from "../../components/SelectContent/TabSelection";

function DocumentRequestPage() {
  const menuItems = [
    {
      key: "tr-local",
      label: "Local Travel Request",
      abbre: "TR",
      component: <TravelRequestLocal />,
      icon: <CarFilled />,
    },
    {
      key: "cos",
      label: "Certificate of Service",
      abbre: "COS",
      component: <CertificateOfServicePage />,
      icon: <CarryOutOutlined />,
    },
    {
      key: "cwa",
      label: "Certificate of Work Accomplishment",
      abbre: "CWA",
      component: <CertificateOfWorkAccomplishmentPage />,
      icon: <FileDoneOutlined />,
    },
    {
      key: "fsr",
      label: "Faculty Service Record",
      abbre: "FSR",
      component: <FacultyServiceRecordPage />,
      icon: <FileTextOutlined />,
    },
  ];

  return (
    <>
      <TabSelection
        menuItems={menuItems}
        currentTabKey="trCurrentTab"
        setTabAction={setTrTab}
      />
    </>
  );
}

export default DocumentRequestPage;
